import {
  REQUEST_PREOPEN_MANAGER_VALIDATED_CLAIMS,
  SET_PREOPEN_MANAGER_VALIDATED_CLAIMS,
  REQUEST_SEARCH,
  SET_SEARCH,
} from 'containers/PreOpenManagerValidatedClaims/constants';

export const requestValidatedClaims = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_PREOPEN_MANAGER_VALIDATED_CLAIMS,
  status,
  page,
  pageSize,
});

export const setValidatedClaims = (response: any) => ({
  type: SET_PREOPEN_MANAGER_VALIDATED_CLAIMS,
  response,
});

export const requestSearch = (searchQuery: any, token?: string) => ({
  type: REQUEST_SEARCH,
  searchQuery,
  token,
});

export const setSearch = (data: any) => ({
  type: SET_SEARCH,
  data,
});
